import React from "react";
import styled from "styled-components";

const Button = styled.button`
    width: 100%;
`;

const RemoveElementButton = ({ element, onElementRemoved }) => {
    
    const handleClick = (event, id) => {
        event.preventDefault();
        onElementRemoved(id);
    }

    return (
        <Button
            onClick={(e) => handleClick(e, element.id)}
        >
            Remove
        </ Button>
    );
};

export default RemoveElementButton;